import styled from "styled-components";

const defaultSize = 32;
const defaultFontSize = 14;
export const CircleMarker = styled.div`
    border-radius: 50%;
    width: ${props => props.size || defaultSize}px;
    height: ${props => props.size || defaultSize}px;
    background-color: ${props => props.color || "black"};
    color: ${props => props.textColor || "white"};
    font-size: ${props => props.fontSize || defaultFontSize}px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
